var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.082 9.13989V7.83594C17.082 5.21694 14.951 3.08594 12.332 3.08594C9.71303 3.08594 7.58203 5.21694 7.58203 7.83594V9.13989C5.64403 9.39689 4.58203 10.6819 4.58203 12.8359V18.8359C4.58203 21.2539 5.91403 22.5859 8.33203 22.5859H16.332C18.75 22.5859 20.082 21.2539 20.082 18.8359V12.8359C20.082 10.6829 19.02 9.39789 17.082 9.13989ZM12.332 4.58594C14.124 4.58594 15.582 6.04394 15.582 7.83594V9.08594H9.08203V7.83594C9.08203 6.04394 10.54 4.58594 12.332 4.58594ZM18.582 18.8359C18.582 20.4129 17.909 21.0859 16.332 21.0859H8.33203C6.75503 21.0859 6.08203 20.4129 6.08203 18.8359V12.8359C6.08203 11.2589 6.75503 10.5859 8.33203 10.5859H16.332C17.909 10.5859 18.582 11.2589 18.582 12.8359V18.8359ZM13.6021 14.8359C13.6021 15.2479 13.39 15.596 13.082 15.823V17.8359C13.082 18.2499 12.746 18.5859 12.332 18.5859C11.918 18.5859 11.582 18.2499 11.582 17.8359V15.7979C11.294 15.5689 11.0969 15.2309 11.0969 14.8359C11.0969 14.1459 11.652 13.5859 12.342 13.5859H12.3521C13.0421 13.5859 13.6021 14.1459 13.6021 14.8359Z",
    fill: "#777E90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.b30b352c8449d04683f13e4ede08667c.svg";
export { ForwardRef as ReactComponent };